module.exports = __webpack_public_path__ + "img/mercedes-banner-right.e9d6ba4f.jpg";